import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { useShallow } from 'zustand/shallow'
import { zustandPlugin } from '@/modules/shared/openreplay'
import { AttestationModel } from '@/app/models/attestation/attestationModel'



type Setter<T> = React.Dispatch<React.SetStateAction<T>>

type State = {
  data: AttestationModel | null

  createForSelectedDrivers: boolean
  downloadAfterGenerate: boolean
}

type Actions = {
  setData: Setter<AttestationModel>
  setCreateForSelectedDrivers: Setter<boolean>
  setDownloadAfterGenerate: Setter<boolean>
}



const initialState: State = {
  data: {
    driverId: '',
    attestationType: 0,
    startTime: '',
    endTime: '',
    activityStartTime: '08:00',
    activityEndTime: '16:00',
    isSequential: true,
    ignoreRestActivity: true,
    shouldInsertActivity: true,
    fillInRemainingTimeWithRestActivity: false,
    attestationTypeBasedOnDayType: false,
    selectedDates: [],
    createdDate: null,
    acceptedDate: null,
    createdDateType: 0,
    acceptedDateType: 0,
    createdPlace: null,
    acceptedPlace: null,
    issuer: null,
    position: null,
    englishVersion: false,
    birthDate: '',
    drivingLicenceNumber: '',
    workStartDate: '',
    searchForNoData: false,
    searchForRestLongerThan: false,
    searchForNoDataHour: 0,
    searchForNoDataMinute: 1,
    searchForRestLongerThanHour: 24,
    searchForRestLongerThanMinute: 0,
  },
  createForSelectedDrivers: false,
  downloadAfterGenerate: false,
}

const makeSetter =
  <K extends keyof State>(
    set: (partial: Partial<State>, replace?: boolean, action?: string) => void,
    get: () => State,
    key: K,
    actionName: string,
  ): Setter<State[K]> =>
  (updater) => {
    const prev = get()[key]
    const next =
      typeof updater === 'function'
        ? (updater as (p: State[K]) => State[K])(prev)
        : updater
    set({ [key]: next } as Partial<State>, false, actionName)
  }

export const useCertificateStore = create<State & Actions>()(
  devtools(
    zustandPlugin(
      (set, get) => ({
        ...initialState,
        setData: makeSetter(set, get, 'data', 'setData'),
        setCreateForSelectedDrivers: makeSetter(
          set,
          get,
          'createForSelectedDrivers',
          'setCreateForSelectedDrivers',
        ),
        setDownloadAfterGenerate: makeSetter(
          set,
          get,
          'downloadAfterGenerate',
          'setDownloadAfterGenerate',
        ),
      }),
      'driver-certificate',
    ),
    { name: 'EasyTacho', store: 'driver-certificate' },
  ),
)

export const useCertificate = () =>
  useCertificateStore(
    useShallow((s) => ({
      data: s.data,
      setData: s.setData,
      createForSelectedDrivers: s.createForSelectedDrivers,
      setCreateForSelectedDrivers: s.setCreateForSelectedDrivers,
      downloadAfterGenerate: s.downloadAfterGenerate,
      setDownloadAfterGenerate: s.setDownloadAfterGenerate,
    })),
  )
